module.exports = __webpack_public_path__ + "img/arctitan-square.a899a2fe.png";